import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { getDevice } from 'utils/clientInfo';
import { useRouter } from 'next/router';

import EditorLayout from '../new/components/layout';
import { Button, Typography } from './base';

export const useDeviceSupport = supportedDevices => {
  const [isSupported, setIsSupported] = useState(true);
  const [currentDevice, setCurrentDevice] = useState();

  useEffect(() => {
    if (Array.isArray(supportedDevices)) {
      const device = getDevice('mobile', 'tablet', 'desktop');
      if (device) {
        if (supportedDevices.indexOf(device) < 0) {
          setIsSupported(false);
        }
        setCurrentDevice(device);
      }
    }
  }, []);

  return [isSupported, currentDevice];
};

const UnsupportedDevice = props => {
  const router = useRouter();

  const handleOnClick = e => {
    e.preventDefault();

    router.push('/');
  };

  return (
    <EditorLayout
      actionButton={
        <Button variant="primary" onClick={handleOnClick}>
          Leave
        </Button>
      }
    >
      <div className="text-center my-3">
        <Typography.Heading size={1} mb={3}>
          Looks like you&apos;re on a {props.device} device
        </Typography.Heading>
        <Typography.Paragraph>
          Unfortunately our editor isn&apos;t compatible for {props.device} screens just yet. Please
          try again on {props.supportedDevices.join(' or ')}.
        </Typography.Paragraph>
      </div>
    </EditorLayout>
  );
};

UnsupportedDevice.propTypes = {
  device: PropTypes.string,
  supportedDevices: PropTypes.array,
};

UnsupportedDevice.defaultProps = {
  device: 'unknown',
  supportedDevices: ['different device'],
};

export default UnsupportedDevice;
